import { MonthCalendar, YearCalendar } from "@mui/x-date-pickers";
import { styled } from "@mui/material";
import Button from "../../../Button";

export const StyledSpecificDatePickerButton = styled(Button, {
  shouldForwardProp: (prop: string) =>
    !["isSelected", "hasValue"].includes(prop),
})<{
  isSelected?: boolean;
  hasValue?: boolean;
}>`
  &.MuiButton-root {
    min-width: auto;
    background-color: ${(props) => props.theme.wsc.palette.neutral[700]};
    padding-right: ${(props) => props.theme.wsc.spacing[1]};

    .MuiButton-endIcon {
      margin: 0;
    }

    ${(props) =>
      props.hasValue
        ? `
			color: ${props.theme.wsc.palette.neutral[300]};
			
			.specific-date-button-value, .MuiButton-endIcon {
				color: ${props.theme.wsc.palette.neutral[100]};
			}
		`
        : `
    	color: ${props.theme.wsc.palette.neutral[100]};
		`}

    ${(props) =>
      props.isSelected &&
      `
			background-color: ${props.theme.wsc.palette.neutral[500]};
			
			&, .specific-date-button-value, .MuiButton-endIcon {
				color: ${props.theme.wsc.palette.primary[500]};
			}
		`}
  }
`;

export const StyledMonthCalendar = styled(MonthCalendar)`
  margin: 0 auto;

  .MuiPickersMonth-monthButton {
    ${(props) => props.theme.wsc.typography.header5};
    width: calc(${(props) => props.theme.wsc.size.m} * 4);
    height: ${(props) => props.theme.wsc.size.xxl};
    padding: 0;
    border-radius: ${(props) => props.theme.wsc.radius.xxl};
    color: ${(props) => props.theme.wsc.palette.neutral[100]};

    &.Mui-selected {
      &,
      &:hover,
      &:focus {
        color: ${(props) => props.theme.wsc.palette.neutral[800]};
        background-color: ${(props) => props.theme.wsc.palette.primary[300]};
      }
    }

    &:not(.Mui-selected):focus {
      background: none;
    }

    &:not(.Mui-selected):hover {
      background-color: ${(props) => props.theme.wsc.palette.neutral[600]};
    }

    &.Mui-disabled {
      color: ${(props) => props.theme.wsc.palette.neutral[400]};
    }
  }
`;

export const StyledYearCalendar = styled(YearCalendar)`
  margin: 0 auto;
  max-height: calc(${(props) => props.theme.wsc.size.m} * 16);

  .MuiPickersYear-yearButton {
    ${(props) => props.theme.wsc.typography.header5};
    width: calc(${(props) => props.theme.wsc.size.m} * 4);
    height: ${(props) => props.theme.wsc.size.xxl};
    padding: 0;
    border-radius: ${(props) => props.theme.wsc.radius.xxl};
    color: ${(props) => props.theme.wsc.palette.neutral[100]};

    &.Mui-selected {
      &,
      &:hover,
      &:focus {
        color: ${(props) => props.theme.wsc.palette.neutral[800]};
        background-color: ${(props) => props.theme.wsc.palette.primary[300]};
      }
    }

    &:not(.Mui-selected):focus {
      background: none;
    }

    &:not(.Mui-selected):hover {
      background-color: ${(props) => props.theme.wsc.palette.neutral[600]};
    }

    &.Mui-disabled {
      color: ${(props) => props.theme.wsc.palette.neutral[400]};
    }
  }
`;
